import React, { useEffect, useState, useMemo } from "react";
import { DatePickerPadrao, InputNumberPadrao, LabelPadrao, ModalPadrao } from "../../components/Base";
import { Select } from "antd";
import { BtnGravar, BtnSair } from "../../components/Buttons";
import InputBlur from "../../components/InputBlur";
import toLocale from "../../Utils/ToLocaleString";
import TabelaPadrao from "../../components/TabelaPadrao";
import dayjs from "dayjs";
import roundCustom from "../../Utils/RoundCustom";
import Mensagens from "../../components/Mensagens";
import SelectFiltros from "../../components/Selects/SelectFiltros";

export default function ModalCrediario({ onOk, onCancel, visible, recebido, nome, hasCliente, idPlanoContaPadrao, edicao }) {
  const INITIAL_FILTROS = { periodicidade: "mensal", parcelas: 1 };

  const [filtros, setFiltros] = useState(INITIAL_FILTROS);
  const [crediarios, setCrediarios] = useState([]);
  const [valor, setValor] = useState(recebido);

  const valorTitulos = useMemo(() => crediarios?.reduce((a, b) => a + b.valor, 0), [crediarios]);

  const columns = [
    {
      Header: "Dias",
      accessor: "dias",
      Cell: props => <InputBlur type="number" value={props.row.original.dias} onChange={v => {
        const row = props.row.original;
        const aux = [...crediarios];
        aux[aux.findIndex(x => x.id === row.id)].vencimento = v == 0 ? dayjs() : dayjs(row.vencimento).add(v - aux[aux.findIndex(x => x.id === row.id)].dias, "d");
        aux[aux.findIndex(x => x.id === row.id)].dias = v;
        setCrediarios(aux);
      }} style={{ width: "30%" }} />
    },
    {
      Header: "Vencimento",
      accessor: "vencimento",
      Cell: props => <DatePickerPadrao value={props.row.original.vencimento} onChange={v => {
        const aux = [...crediarios];
        const inx = aux.findIndex(x => x.id === props.row.original.id);
        aux[inx].vencimento = v;
        aux[inx].dias = v.diff(dayjs(), 'days') + 1;
        setCrediarios(aux);
      }} style={{ width: "100%" }} />
    },
    {
      Header: "Valor",
      accessor: "valor",
      tipo: "right",
      Cell: props => <InputBlur min={0} value={props.row.original.valor} onChange={v => {
        const aux = [...crediarios];
        aux[aux.findIndex(x => x.id === props.row.original.id)].valor = v;
        setCrediarios(aux);
      }} style={{ width: "100%" }} />,
      Footer: toLocale(valorTitulos)
    }
  ];

  const handleParcelaChange = (valorInterno, parcelas) => {

    const aux = [];
    const subtract = parcelas < 0;
    for (let i = parcelas == 0 ? -1 : 0; subtract ? i > parcelas : i < parcelas; subtract ? i-- : i++) {
      if (parcelas > 21) break;
      var tp = filtros.periodicidade;

      var count = subtract ? i - 1 : i + 1;

      const vencTitulo = dayjs();

      var vencimento = vencTitulo.add(7 * count, "d");
      if (tp === "quinzenal") vencimento = vencTitulo.add(15 * count, "d");
      if (tp === "mensal") vencimento = vencTitulo.add(1 * count, "M");
      if (tp === "bimestral") vencimento = vencTitulo.add(2 * count, "M");
      if (tp === "trimestral") vencimento = vencTitulo.add(3 * count, "M");
      if (tp === "semestral") vencimento = vencTitulo.add(6 * count, "M");
      if (tp === "anual") vencimento = vencTitulo.add(count, "y");

      const dias = vencimento.diff(dayjs(), 'days');

      var valorParcela = roundCustom(valorInterno / (Math.abs(parcelas) == 0 ? 1 : Math.abs(parcelas)));

      aux.push({ id: count, dias: dias, vencimento, valor: valorParcela });
    }

    if (aux.length) {
      var dif = roundCustom(valorInterno - aux.reduce((a, b) => a + b.valor, 0));
      aux[0].valor = roundCustom(aux[0].valor += dif);
    }

    setCrediarios(aux);
  };

  useEffect(() => {
    if (visible && filtros.reset != undefined)
      handleParcelaChange(valor, filtros.parcelas);

  }, [filtros.reset]);

  useEffect(() => {
    if (visible && !!edicao) {
      setCrediarios(edicao.crediarios);
      setValor(edicao.valor);
      setFiltros({ ...edicao.filtros, reset: undefined });
    }
    else if (visible) {
      setValor(recebido);
      setFiltros({ ...INITIAL_FILTROS, idPlanoConta: idPlanoContaPadrao });
      handleParcelaChange(recebido, INITIAL_FILTROS.parcelas);
    }
    else {
      setCrediarios([]);
      setFiltros(INITIAL_FILTROS);
    }
  }, [visible]);


  return <ModalPadrao title={`Informe os títulos para o crediário: ${nome}`} visible={visible} closable={false} footer={<>
    {!!hasCliente && <BtnGravar disabled={!crediarios?.length} txt="Confirmar" onClick={() => {
      if (!valor)
        return Mensagens.showWarning("Valor não informado!");
      else if (!filtros.idPlanoConta)
        return Mensagens.showWarning("Plano de contas não informado!");

      onOk({ crediarios, valor, idPlanoConta: filtros.idPlanoConta, filtros });
    }} />}
    <BtnSair onClick={() => edicao ? onOk(edicao) : onCancel()} />
  </>
  }>
    {hasCliente ? <>
      {!idPlanoContaPadrao && <SelectFiltros noMargin title="Plano de contas" modelo="grupoconta" tipo="cr" placeholder="Selecione plano de contas" value={filtros.idPlanoConta} onChange={v => setFiltros({ ...filtros, idPlanoConta: v })} />}

      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <div style={{ width: 200, marginRight: 10 }}>
          <LabelPadrao>Valor</LabelPadrao>
          <InputBlur value={valor} onChange={v => { setValor(v); setFiltros({ ...filtros, parcelas: INITIAL_FILTROS.parcelas, reset: !filtros.reset }); }} max={recebido} min={0} />
        </div>
        <div style={{ width: 200 }}>
          <LabelPadrao>Tipo parcela</LabelPadrao>
          <Select value={filtros.periodicidade} onChange={v => setFiltros({ ...filtros, periodicidade: v })} style={{ width: "100%" }} placeholder="periodicidade">
            <Select.Option value="semanal">Semanal</Select.Option>
            <Select.Option value="quinzenal">Quinzenal</Select.Option>
            <Select.Option value="mensal">Mensal</Select.Option>
            <Select.Option value="bimestral">Bimestral</Select.Option>
            <Select.Option value="trimestral">Trimestral</Select.Option>
            <Select.Option value="semestral">Semestral</Select.Option>
            <Select.Option value="anual">Anual</Select.Option>
          </Select>
        </div>

        <div style={{ width: 100, margin: "0 10px" }}>
          <LabelPadrao>Parcelas</LabelPadrao>
          <InputNumberPadrao max={20} value={filtros.parcelas} onChange={v => setFiltros({ ...filtros, parcelas: v, reset: !filtros.reset })} style={{ width: "100%" }} />
        </div>

        <LabelPadrao style={{ width: "50%" }}>{`x ${toLocale(filtros.parcelas ? valor / (filtros.parcelas < 0 ? -filtros.parcelas : filtros.parcelas) : valor)}`}</LabelPadrao>
      </div>
      <TabelaPadrao columns={columns} style={{ marginTop: 20 }} data={crediarios} />
    </> : <h3 style={{ textAlign: "center" }}>Nenhum cliente informado, selecione um cliente ou mude a forma de pagamento.</h3>}

  </ModalPadrao>;
}